module.exports = __webpack_public_path__ + "static/media/burger-close.6bc6dc42.svg";